import React, { useEffect, useState } from 'react'
import PageTitle from '../../Utility/PageTitle'
import { Button, Card, Modal, Result, Skeleton, Tabs } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useFetch } from '../../../services/ApiService';
import ApplicationDetails from './ApplicationDetails';
import ApplicationHistory from './ApplicationHistory';
import ExamDetails from './ExamDetails';
import ExamResult from './ExamResult';


function View() {
    const { id } = useParams();
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { fetchApi } = useFetch();
    const { TabPane } = Tabs;

    const getData = async (applicationId) => {
        setLoading(true);
        await fetchApi(`/api/application?id=${applicationId}`, 'GET', {}, {
            "x-api-key": "ABCD-123"
        }).then(res => {
            if (res.length > 0) {
                setData(res[0]);
            }
        }).catch(err => {
            console.log(err);
        })
        setLoading(false);
    }


    const refreshData = () => {
        getData(id)
    }


    useEffect(() => {
        getData(id)
    }, [id])

    return (
        <>
            <PageTitle title="Application" />
            <Skeleton loading={loading}>
                {
                    Object.keys(data).length > 0 ?
                        <Tabs
                            animated={{ inkBar: true, tabPane: true }}
                            defaultActiveKey="1"
                            className='mb-0 pb-0 mt-5'
                        >
                            <TabPane className='pt-0' tab={
                                <span className='d-flex align-items-center'>

                                    Application Details
                                </span>
                            } key="1">

                                <ApplicationDetails data={data} loading={loading} getData={getData} refreshData={refreshData} />


                            </TabPane>
                            <TabPane className='pt-0' tab={
                                <span className='d-flex align-items-center'>

                                    Application History
                                </span>
                            } key="2">
                                <Card
                                    loading={loading}

                                >
                                    <ApplicationHistory applicationData={data} refreshData={refreshData} />
                                    <div className='text-center'>
                                        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/application-list')}>Go back</Button>
                                    </div>
                                </Card>
                            </TabPane>
                            {

                                data.status_id === 6 &&
                                <TabPane className='pt-0' tab={
                                    <span className='d-flex align-items-center'>
                                        Examination Details
                                    </span>
                                } key="3">
                                    <Card
                                        loading={loading}
                                    >
                                        <ExamResult applicationData={data} refreshData={refreshData} />
                                        <div className='text-center mt-5'>
                                            <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/application-list')}>Go back</Button>
                                        </div>
                                    </Card>
                                </TabPane>
                            }
                        </Tabs>
                        :
                        <Card>
                            <Result
                                status="403"
                                title="403"
                                subTitle="Application does not exists or you don't have rights to access this application."
                                extra={<Button><Link to='/applications-list' className='ant-btn btn-primary'>Go Back to Applications</Link></Button>}
                            />
                        </Card>
                }
            </Skeleton>
        </>
    )
}

export default View